import { isValidElement } from 'react';
import type { MenuItem, MenuNode } from '../../../common/types';

export const hasSubmenuItems = (menuNode: MenuItem) =>
	isValidElement(menuNode.element) || (!!menuNode.children && menuNode.children.length > 0);

export const isSubmenuOpen = (openPath: string | undefined): openPath is string => !!openPath;

export const isSubmenuOpenForNode = (menuNode: MenuNode, openPath: string | undefined): boolean =>
	isSubmenuOpen(openPath) && menuNode.id.startsWith(openPath);
